import { colors, IIconProps } from '@vst/beam';
import { Construction, Language, OndemandVideo, Phone, Security, Wifi, Work } from '@vst/beam-icons/icons';

export type VisualConfig = {
  icon: IIconProps['icon'];
  beamIconColorName: IIconProps['color'];
  hexColorValue: string;
  backgroundColor: string;
};

export const addonVisualConfig: Record<string, VisualConfig> = {
  VOICE: {
    backgroundColor: colors.blue['100'],
    hexColorValue: colors.blue['600'],
    beamIconColorName: 'blue_600',
    icon: Phone,
  },
  SHIELD: {
    backgroundColor: colors.warm['100'],
    hexColorValue: colors.warm['600'],
    beamIconColorName: 'warm_600',
    icon: Security,
  },
  CYBER_PROTECT: {
    backgroundColor: colors.violet['100'],
    hexColorValue: colors.violet['600'],
    beamIconColorName: 'violet_600',
    icon: Security,
  },
  EASY_CARE: {
    backgroundColor: colors.green['100'],
    hexColorValue: colors.green['600'],
    beamIconColorName: 'green_600',
    icon: Construction,
  },
  OFFICE_HOURS: {
    backgroundColor: colors.pink['100'],
    hexColorValue: colors.pink['500'],
    beamIconColorName: 'pink_500',
    icon: Work,
  },
  STREAM: {
    backgroundColor: colors.violet['100'],
    hexColorValue: colors.violet['500'],
    beamIconColorName: 'violet_500',
    icon: OndemandVideo,
  },
  STATIC_IP: {
    backgroundColor: colors.gray['200'],
    hexColorValue: colors.gray['700'],
    beamIconColorName: 'gray_700',
    icon: Language,
  },
  DEFAULT: {
    backgroundColor: colors.blue['100'],
    hexColorValue: colors.blue['600'],
    beamIconColorName: 'blue_600',
    icon: Wifi,
  },
};
